import { SET_RUNTIME_VARIABLE } from "../../constants";
import { getAvailableLanguages as query, getDefaultMobileLanguage as defaultLanguage, getActiveLanguages as activeQuery } from "../../lib/graphql";
import { formatLocaleData } from "../formatLocale";

const getDynamicName = ({ value, locale, data }) => {
    let language = formatLocaleData(locale)
    let result = data?.find(item => (item?.typeId == value?.typeId || value?.id) && (item?.listSettingsId == value?.id) && (item?.language == language)) || value;
    return result;
}

export const getLanguageCode = (locale) => {
    const localeCode = {
        'en-US': 'en',
        'en': 'en',
        'ar': 'ar',
        'es': 'es',
        'fr-FR': 'fr',
        'fr': 'fr',
        'it-IT': 'it',
        'it': 'it',
        'pt-PT': 'pt',
        'pt': 'pt'
    };

    return localeCode[locale] || 'en';
}

export const availableLanguages = ['en', 'es', 'it', 'fr', 'pt', 'ar']

const getDynamicTitle = ({ locale, data, id }) => {
    let language, result;
    language = formatLocaleData(locale)
    result = data?.find(value => (value?.language == language) && (value?.listId == id));
    return result?.listTitle;
}

const getDynamicDescription = ({ locale, data, id }) => {
    let language, result;
    language = formatLocaleData(locale)
    result = data?.find(value => (value?.language == language) && (value?.listId == id));
    return result?.listDescription;
}

const getDynamicPolicyName = ({ locale, data, value }) => {
    let language, result;
    language = formatLocaleData(locale)
    result = data?.find((item) => (item.language == language) && (item?.cancellationId == value?.id))
    return result ? result : value
}
const getDynamicPolicyInfo = ({ locale, data }) => {
    let language, result;
    language = formatLocaleData(locale)
    result = data?.find((item) => item.language == language)
    return result || null
}

const getAvailableLanguages = () => {
    return async (dispatch, getState, { client }) => {

        try {

            const { data } = await client.query({
                query,
                variables: { appType: 'android_app' },
                fetchPolicy: 'network-only'
            });

            if (data?.getAvailableLanguages?.status == 200) {
                let isAvailableLanguages = []
                data?.getAvailableLanguages?.results?.map((item) => {
                    if (item?.languageCode) isAvailableLanguages.push(item?.languageCode)
                })

                dispatch({
                    type: SET_RUNTIME_VARIABLE,
                    payload: {
                        name: 'availableLanguage',
                        value: isAvailableLanguages || ['en'],
                    }
                });

                return isAvailableLanguages || ['en']
            }

        } catch (error) {
            return false;
        }
        return true;
    }
}

const getDefaultMobileLanguage = () => {
    return async (dispatch, getState, { client }) => {
        try {

            const { data } = await client.query({
                query: defaultLanguage,
                variables: { appType: 'android_app' },
                fetchPolicy: 'network-only'
            });

            if (data?.getDefaultMobileLanguage?.status == 200) {
                return data?.getDefaultMobileLanguage?.result?.languageCode
            }

        } catch (error) {
            return false;
        }
        return true;
    }
}

const getDynamicAdminItemName = ({ value, locale, data }) => {
    try {
        let language = formatLocaleData(locale);
        let result = data?.find(item => {
            return item.language === language;
        });
        return result ? result?.itemName : value;
    } catch (e) {
        return null;
    }
};


const getActiveLanguages = () => {
    return async (dispatch, getState, { client }) => {
        try {

            const { data } = await client.query({
                query: activeQuery,
                variables: { appType: 'android_app' },
                fetchPolicy: 'network-only'
            });

            if (data?.getActiveLanguages?.status == 200) {
                let isAvailableLanguages = []
                data?.getActiveLanguages?.results?.map((item) => {
                    if (item?.languageCode) isAvailableLanguages.push(item?.languageCode)
                })

                dispatch({
                    type: SET_RUNTIME_VARIABLE,
                    payload: {
                        name: 'isActiveLanguages',
                        value: isAvailableLanguages || ['en'],
                    }
                });
            }

        } catch (error) {
            return false;
        }
        return true;
    }
}


export {
    getDynamicName,
    getDynamicTitle,
    getDynamicDescription,
    getAvailableLanguages,
    getDefaultMobileLanguage,
    getActiveLanguages,
    getDynamicPolicyName,
    getDynamicPolicyInfo,
    getDynamicAdminItemName
};